module.exports = __webpack_public_path__ + "img/seminar2.6f71ab0d.jpg";